import React from 'react';
import { FormNumber } from '@digital/ui';
import { Props } from '@digital/ui/lib/components/FormNumber';
import { thousandSeparator } from '@app/helpers/stringHelper';

const CurrencyInput = ({
    ...props
}: Props &
    import('@digital/ui/lib/components/FormItem').FormItemProps &
    import('antd/lib/input-number').InputNumberProps) => {
    const handleParser = (number: string | undefined) => {

        if (!number) {
            return '';
        }

        var negative = number.includes('-') ? '-' : '';
        let valor = number.replace(/[^0-9]/gm, '');
        let valorFloat = parseFloat(valor) / 100;
        if (isNaN(valorFloat)) return '0,00';
        return negative + valorFloat.toFixed(2);
    };

    return <FormNumber parser={handleParser} formatter={e => thousandSeparator(e)} {...props} />;
};

export default CurrencyInput;
